import {joinPodUrl} from '../joinPodUrl';
import {normalizeLoxoPodUrl} from '../podUrl';

export type ExchangeAuthTokensJson = {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
};

export const exchangeAuthTokens = async (
  podUrl: string,
  exchangeCode: string
): Promise<ExchangeAuthTokensJson> => {
  const safePodUrl = normalizeLoxoPodUrl(podUrl);
  const response = await fetch(joinPodUrl(safePodUrl, '/auth/exchange_token'), {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({exchange_code: exchangeCode}),
  });

  const body: unknown = await response.json().catch(() => null);
  if (!response.ok || !body || typeof body !== 'object') {
    const errors = (body as {errors?: string[]})?.errors;
    const message =
      Array.isArray(errors) && errors[0]
        ? errors[0]
        : 'Could not complete sign-in.';
    throw new Error(message);
  }

  const access_token = (body as {access_token?: unknown}).access_token;
  const refresh_token = (body as {refresh_token?: unknown}).refresh_token;
  if (typeof access_token !== 'string' || typeof refresh_token !== 'string') {
    throw new Error('Could not complete sign-in.');
  }

  return body as ExchangeAuthTokensJson;
};
